import { render, staticRenderFns } from "./AnesthesiaDescriptionQuestionType.vue?vue&type=template&id=be562cb2&scoped=true"
import script from "./AnesthesiaDescriptionQuestionType.vue?vue&type=script&lang=js"
export * from "./AnesthesiaDescriptionQuestionType.vue?vue&type=script&lang=js"
import style0 from "./AnesthesiaDescriptionQuestionType.vue?vue&type=style&index=0&id=be562cb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be562cb2",
  null
  
)

export default component.exports